import { store } from '../../store'
import { http } from '../../main'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  project_get ({ commit, dispatch }, payload) {
    let id = payload.event.id ? payload.event.id : store.state.userLogged.company[0].id
    let url = 'api/projects/getProjects/' + id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('projectGet', {event: payload.event, response: response})
        },
        error => {
          commit('projectError', {event: payload.event, error: error})
        }
      )
  },
  inactive_project_get ({ commit, dispatch }, payload) {
    let id = payload.event.id ? payload.event.id : store.state.userLogged.company[0].id
    let url = 'api/projects/projects-deactivate/' + id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('inactiveProjectGet', {event: payload.event, response: response})
        },
        error => {
          commit('inactiveProjectError', {event: payload.event, error: error})
        }
      )
  },
  project_post ({ commit, dispatch }, payload) {
    let url = 'api/projects'
    let params = {
      'name': payload.event.name,
      'business_unit': payload.event.business_unit,
      'external_project_id': payload.event.external_project_id,
      'company_id': payload.event.company,
      'status': 1
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.post(url, params, {})
      .then(
        response => {
          commit('projectPost', {event: payload.event, response: response})
        },
        error => {
          commit('projectError', {event: payload.event, error: error})
        }
      )
  },
  project_put ({ commit, dispatch }, payload) {
    let url = 'api/projects/' + payload.event.item.id
    let params = {
      'name': payload.event.item.name,
      'business_unit': payload.event.item.business_unit,
      'external_project_id': payload.event.item.external_project_id,
      'company_id': payload.event.item.company_id,
      'status': payload.event.item.status
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.put(url, params, {})
      .then(
        response => {
          commit('projectPut', {event: payload.event, response: response})
        },
        error => {
          commit('projectError', {event: payload.event, error: error})
        }
      )
  },
  project_delete ({ commit, dispatch }, payload) {
    let url = 'api/projects/' + payload.event.item.id
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.delete(url, {}, {})
      .then(
        response => {
          commit('projectDelete', {event: payload.event, response: response})
        },
        error => {
          commit('projectError', {event: payload.event, error: error})
        }
      )
  },
  project_activate ({ commit, dispatch }, payload) {
    let url = 'api/projects/activateProject/' + payload.event.item.id
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.post(url, {}, {})
      .then(
        response => {
          commit('projectActivate', {event: payload.event, response: response})
        },
        error => {
          commit('projectError', {event: payload.event, error: error})
        }
      )
  },
  project_deactivate ({ commit, dispatch }, payload) {
    let url = 'api/projects/deactivateProject/' + payload.event.item.id
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.post(url, {}, {})
      .then(
        response => {
          commit('projectDeactivate', {event: payload.event, response: response})
        },
        error => {
          commit('projectError', {event: payload.event, error: error})
        }
      )
  },
  company_get ({commit, dispatch}, payload) {
    let url = 'api/company/1'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('companyGet', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  },
  getByCompany ({commit, dispatch}, payload) {
    let url = 'api/projects/getProjects/' + payload.event.company_id
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('projectGet', {event: payload.event, response: response})
        },
        error => {
          commit('deactiveProjectError', {event: payload.event, error: error})
        }
      )
  }
}

// mutations
const mutations = {
  // Set the data obtained from the users endpoint
  projectGet (state, payload) {
    let projects = payload.response.data.data
    let activeProjects = []
    if (projects && projects.length > 0) {
      activeProjects = projects.filter(project => project.status === 1)
    }
    payload.event.context.projects = activeProjects
    payload.event.context.loadingItems = false
  },
  inactiveProjectGet (state, payload) {
    let inactiveProjects = payload.response.data.data
    payload.event.context.inactiveProjects = inactiveProjects
  },
  // Add the data from the new user to the users list
  projectPost (state, payload) {
    let project = payload.response.data.data
    project.name = project.name
    project.business_unit = project.business_unit
    project.external_project_id = project.external_project_id
    project.company_id = project.company_id
    project.status = project.status
    payload.event.context.showNotification(payload.response, 'success')
    let projects = []
    if (payload.event.context.projects !== undefined) {
      projects = payload.event.context.projects
    }
    projects.push(project)
    payload.event.context.close()
  },
  // Updates the data displayed for the modified user
  projectPut (state, payload) {
    let project = payload.response.data.data
    project.name = project.name
    project.business_unit = project.business_unit
    project.external_project_id = project.external_project_id
    project.company_id = project.company_id
    project.status = project.status
    let projects = payload.event.context.projects
    projects.splice(payload.event.index, 1, project)
    payload.event.context.projects = projects
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.close()
  },
  // Removes the data of the deleted user from the users list
  projectDelete (state, payload) {
    let projects = payload.event.context.projects
    projects.splice(payload.event.index, 1)
    payload.event.context.projects = projects
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.removeDialog = false
    payload.event.context.loading = false
    payload.event.context.refresh()
  },
  projectActivate (state, payload) {
    let projects = payload.event.context.projects
    projects.splice(payload.event.index, 1)
    payload.event.context.projects = projects
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.activateDialog = false
    payload.event.context.loading = false
    payload.event.context.refresh()
  },
  projectDeactivate (state, payload) {
    let projects = payload.event.context.projects
    projects.splice(payload.event.index, 1)
    payload.event.context.projects = projects
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.deactivateDialog = false
    payload.event.context.loading = false
    payload.event.context.refresh()
  },
  // Shows a error message
  projectError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
  },
  inactiveProjectError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.inactiveProjects = []
    payload.event.context.loading = false
  },
  companyGet (state, payload) {
    let company = payload.response.data.data.id
    payload.event.context.company = company
    payload.event.context.defaultItem.company_id = company
    payload.event.context.editedItem.company_id = company
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/projects.js